import { CALL_API } from 'redux-api-middleware'
import { push } from 'react-router-redux'
import { token } from '../utils'

import {
  SEARCH_KEYWORD_REQUEST,
  SEARCH_KEYWORD_SUCCESS,
  SEARCH_KEYWORD_FAILURE,
} from './types'

const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadSearchPages = (keyword) => {
  return (dispatch) => {
    dispatch(
      push({
        pathname: `/search/${keyword}`,
      })
    )
  }
}

export const onSearchHandle = (endpoint, keyword) => {
  const formData = new FormData()
  formData.append('keyword', keyword)
  return {
    [CALL_API]: {
      endpoint,
      method: 'POST',
      headers,
      body: formData,
      types: [SEARCH_KEYWORD_REQUEST, SEARCH_KEYWORD_SUCCESS, SEARCH_KEYWORD_FAILURE],
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js